import { getTreatmentsExtensionForGraphqlBody } from '@ms/yammer-data/dist/api';
import { getClientForwardExperiments } from '@ms/yammer-data/dist/domains/experiments/selectors';
import type { Store } from '@ms/yammer-data/dist/state/types';
import type { LazyRelayAppWrapperProps } from '@ms/yammer-relay/dist/environment';
import type { YammerTeamsEventState } from 'state/types';

import config from '../../bootstrap/config';

import { getTeamsMeetingRelayHeaders } from './getTeamsMeetingRelayHeaders';

export const getLazyRelayAppWrapperProps = (
  store: Store<YammerTeamsEventState>,
  etag?: string
): LazyRelayAppWrapperProps => {
  const state = store.getState();

  const experiments = getClientForwardExperiments(state);
  const treatments = getTreatmentsExtensionForGraphqlBody({
    state,
    experiments,
  });
  const teamsMeetingHeaders = getTeamsMeetingRelayHeaders(state);

  return {
    authScope: config.adal.resources.yammer,
    host: config.hosts.graphql,
    treatments,
    etag,
    additionalHeaders: teamsMeetingHeaders,
  };
};
